module.exports = __webpack_public_path__ + "static/media/cart.2814d7c6.svg";